import React, { useEffect } from 'react';
import { Button, Badge } from 'components/lib';
import Style from './table.module.scss';

export function Body(props){

  if (props.data?.length){
    return (
      <tbody>
        { props.data.map((row, index) => {
          
          return <Row {...props } data={ row } key={ row.id || row._id || index }/>

        })}
      </tbody>
    );
  }

  return (
    <tbody>
      <tr>
        <td colSpan='10'>No results found</td>
      </tr>
    </tbody>
  );
}

export function Row(props){
  const [row, setRow] = React.useState({...props.data, actions: props.data.actions || props.actions});

  /**
   * If action returns a partial object matching row's keys, then 
   * the row's values are updated
   */
  const handleAction = async (action, row) => {
    const result = await action(row);
    if (!result) return;

    const newKeys = Object.keys(result).filter(key => row.hasOwnProperty(key));
    if (!newKeys) return;
    
    let updatedValues = {...row};
    newKeys.forEach(key => updatedValues[key]=result[key]);
    
    setRow(updatedValues);
  }

  return(
    <tr data-id={ props.data.id }
      onClick={props.onRowClick ? () => props.onRowClick(props.data) : undefined}
      tabIndex={props.onRowClick ? 0 : undefined}
      aria-label={props.onRowClick ? `Ver lista ${props.data.name}` : undefined}
      onKeyDown={props.onRowClick ? event => {
        if (event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          props.onRowClick(props.data);
        }
      } : undefined}
      style={props.onRowClick ? {cursor: 'pointer'} : undefined}>
      { Object.keys(row).map((cell, index) => {

        // actions
        if (cell === 'actions'){
            return (
              <td key={ index } className={ Style.actions }>

                { row.actions?.custom?.map((action, i) => {
                  // url_linkedin={action.icon && action.icon === 'linkedin' ? row.url_linkedin : null}
                  if(action.icon !== 'check_action') return <Button key={ i } icon={ action.icon } action={ () => handleAction(action.action, row) }/>
                  else return <input
                    key={ i }
                    type='checkbox'
                    aria-label={`Seleccionar lista ${props.data.name || ''}`}
                    checked={props.data.check === 'checked'}
                    onChange={() => (props.data.actions || props.actions).custom[i].action(props.data)}
                    style={{ width: 20, height: 20, cursor: 'pointer', margin: 0 }}
                  />
                })}
                
                { row.actions.edit &&
                  <Button icon='edit' action={ () => row.actions.edit(row, (res) => props.callback.edit(res, row) )}/>}

                { row.actions.download &&
                  <Button icon='download' url={ row.actions.download }/>}

                { row.actions.view &&
                  <Button icon='eye' url={ `${row.actions.view}/${row.id}` }/>}

                { row.actions.email &&
                  <Button icon='mail' action={ () => window.location = `mailto:${row.email}` }/>}

                { row.actions.invite &&
                  <Button icon='mail' action={ e => row.actions.invite(row) }/> }
                                   
                { row.actions.delete &&
                  <Button icon='trash' action={ () => row.actions.delete(row, (res) => props.callback.delete(res, row)) }/>}
                  
              </td>
            );
        }

        // hide
        if (props.hide?.includes(cell))
          return false;

        // show
        if (props.show && !props.show.includes(cell))
          return false;

        let value = row[cell];

        // is date
        if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(value))
          value = new Date(value).toISOString().split('T')[0];

        // has badge
        if (value && props.badge && cell === props.badge.col){

          // default color
          let color = props.badge.color;

          // check each condition
          if (props.badge.condition){
            props.badge.condition.forEach(cond => {

              color = cond.value.toLowerCase() === value.toLowerCase() ? cond.color : color;

            });
          } 
   
          return (
            <td key={ index }>
              <Badge text={ value } color={ color }/>
            </td>
          );
        }

        // standard cell
        return(
          <td key={ index }>
            { value === true  ? 'Yes' : (value === false ? 'No' : value) }
          </td>
        );
      })}
    </tr>
  );
}
